import { SpherePlatformAppPaths } from '@sphere/platform';

export const NA_POWER_MARKETS_PATH = 'na-power-markets';
export const NA_POWER_MARKETS_ISO_DASHBOARD_PATH = 'iso-dashboard';

export const PATHS: SpherePlatformAppPaths = {
    ['NA_POWER_MARKETS_PATH']: 'na-power-markets',
    ['NA_POWER_MARKETS_ISO_DASHBOARD_PATH']: 'iso-dashboard'
};
